//import { DatePipe } from "@angular/common/src/pipes";
import { Pipe, PipeTransform } from '@angular/core';
import { LookupService } from '../services/lookups/lookup.service';
import { DatePipe } from "@angular/common";


@Pipe({
    name: 'evdate',
    pure: true
})
export class ConvertDatePipe extends DatePipe implements PipeTransform {
    constructor(private ls: LookupService) {
        super("en");
    }

    transform(value: any, pattern?: string): string | null {
        let evPattern = this.ls.getDefaultValue(40033, pattern); //40033 EV DATE FORMAT EN,
        return super.transform(value, evPattern);
    }

}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/pipes/convert-date.pipe.ts